import gql from 'graphql-tag';
import {
  useMutation,
  type MutationFunctionOptions,
  type FetchResult,
} from '@apollo/react-hooks';

const UPDATE_SUBJECT_CLASSIFICATION = gql`
  mutation (
    $applicationId: String!
    $subjectClassification: FUNDING_PANEL!
    $competitiveStudentship: Float
  ) {
    updateScholarshipSubjectClassification(
      applicationId: $applicationId
      subjectClassification: $subjectClassification
      competitiveStudentship: $competitiveStudentship
    ) {
      __typename
    }
  }
`;

export const useUpdateSubjectClassification = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [updateSubjectClassification] = useMutation(
    UPDATE_SUBJECT_CLASSIFICATION,
  );
  return updateSubjectClassification;
};
